import store from "./../store/store";
// import { setSnackbarError } from "../utils/utils";

export const authorizationGuard = (to, from, next) => {
  store.state.pagination.co.pageIndex = 0;
  const guardAction = async () => {
    await store.dispatch("auth/loadAuthCookie").then(async (response) => {
      let isAuthenticated = response;

      let userRoleList = store.state.auth.userRoleList || [];
      if (isAuthenticated) {
        if (Object.entries(store.state.auth.userInfo).length === 0) {
          await store.dispatch("auth/loadUserInfo");
        }
        if (userRoleList.length <= 0) {
          await store.dispatch("auth/loadUserRoleList").then(async (response) => {
            // Safe assignment with fallback
            userRoleList = response || [];
          });
        }

        // Ensure userRoleList is valid before checking length
        if (userRoleList && userRoleList.length > 0) {
          if (to.meta && to.meta.authorize && to.meta.authorize.length > 0) {

            // LOGIC FIX: Check if User has AT LEAST ONE of the required roles
            let hasAuthorizedRole = false;

            // Check intersection
            for (let allowedRole of to.meta.authorize) {
              if (userRoleList.includes(allowedRole)) {
                hasAuthorizedRole = true;
                break;
              }
            }

            if (hasAuthorizedRole) {
              return next();
            } else {
              // User has roles, but none of them are allowed for this route
              return next({ name: "Error" });
            }
          } else {
            // Route has no specific authorization rules (authorize: [])
            return next();
          }
        } else {
          // User authenticated but has NO roles? 
          // If route requires auth, this might be an issue, but for now fallback to Error or allow if no meta.
          if (to.meta && to.meta.authorize && to.meta.authorize.length > 0) {
            return next({ name: "Error" });
          }
          return next();
        }
      } else {
        await store.dispatch("auth/loadLogout");
        // Ensure we don't hang the navigation if logout doesn't immediately redirect
        if (to.name !== 'Login') {
          return next({ name: "Login" });
        }
        return next();
      }
    });
  };
  return guardAction();
};
